var _circle, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEllipse = function SvgEllipse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 725,
    height: 725,
    viewBox: "0 0 725 725",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 362.5,
    cy: 362.5,
    r: 362.5,
    fill: "url(#paint0_linear_1140_4566)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1140_4566",
    x1: 362.5,
    y1: 0,
    x2: 362.5,
    y2: 417.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24213A"
  })))));
};

export { SvgEllipse as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzI1IiBoZWlnaHQ9IjcyNSIgdmlld0JveD0iMCAwIDcyNSA3MjUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjM2Mi41IiBjeT0iMzYyLjUiIHI9IjM2Mi41IiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfMTE0MF80NTY2KSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzExNDBfNDU2NiIgeDE9IjM2Mi41IiB5MT0iMCIgeDI9IjM2Mi41IiB5Mj0iNDE3LjE3NSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjM0IzNzU2Ii8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzI0MjEzQSIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";